module.exports = __webpack_public_path__ + "img/about-us.37d91d27.jpg";